import { useTheme } from "./ThemeProvider"

/** Theme-aware brand identity: fairy mode rebrands the whole surface. */
export function useBrand() {
  const { theme } = useTheme()
  const isFairy = theme === "fairy"
  return {
    isFairy,
    name: isFairy ? "Sales Fairy" : "Sales Demon",
    wordmark: isFairy ? "SalesFairy" : "SalesDemon",
    sprite: isFairy ? "/assets/pixel/fairy_16.png" : "/assets/pixel/demon_16.png",
  }
}
